import { defineStore } from 'pinia';

export const useCommentStore = defineStore('comment', {
  state: () => {
    return {
      areCommentsDisplayed: {},
      isTextEditorDisplayed: {},
      commentsByContentList: {},
      lastCommentCreated: null,
    };
  },
  actions: {
    notifyCommentCreated({ type, id }) {
      if (!type || id == null) return;
      this.lastCommentCreated = { type, id, nonce: Date.now() };
    },
    primeCommentsByContentKey({ type, id, comments }) {
      const key = `${type}-${id}`;
      this.commentsByContentList = {
        ...this.commentsByContentList,
        [key]: Array.isArray(comments) ? comments : [],
      };
    },
    primeMultipleComments({ postComments, feedItemTypeToRouteType }) {
      if (!Array.isArray(postComments) || typeof feedItemTypeToRouteType !== 'function') return;

      const next = { ...this.commentsByContentList };

      for (const entry of postComments) {
        if (!entry) continue;
        const { id, feed_item_type, comments } = entry;
        const routeType = feedItemTypeToRouteType(feed_item_type);
        if (!routeType || id == null) continue;
        next[`${routeType}-${id}`] = Array.isArray(comments) ? comments : [];
      }

      this.commentsByContentList = next;
    },
    handleDisplayComments({ type, id }) {
      const key = `${type}-${id}`;
      if (!(key in this.areCommentsDisplayed)) {
        this.areCommentsDisplayed = {
          ...this.areCommentsDisplayed,
          [key]: false,
        };
      } else {
        this.areCommentsDisplayed = {
          ...this.areCommentsDisplayed,
          [key]: !this.areCommentsDisplayed[key],
        };
      }
    },
    handleDisplayTextEditor({ type, id }) {
      const key = `${type}-${id}`;
      if (!(key in this.isTextEditorDisplayed)) {
        this.isTextEditorDisplayed = {
          ...this.isTextEditorDisplayed,
          [key]: true,
        };
      } else {
        this.isTextEditorDisplayed = {
          ...this.isTextEditorDisplayed,
          [key]: !this.isTextEditorDisplayed[key],
        };
      }
    },
  },
});
